import SectionText from '@mshops-components-library/section-text';
import WrapperSectionText from './Wrapper';

export default WrapperSectionText(SectionText);
